import React, { useEffect, useMemo, useState } from 'react';
import {SelectorRefrenciasFacturaexpatriadosContainer as SelectorRefrenecias}  from '../../../../../components/Selectores/ReferenciasFacturaExpatriados/container';
import { SelectorGruposFacturaExpatriadosContainer as SelectorGrupos } from '../../../../../components/Selectores/GruposFacturaExpatriados/container';
import { EuiCollapsibleNavGroup, EuiFlexGroup, EuiFlexItem, EuiFormRow } from '@elastic/eui';
import { ROLES_EXPATRIADOS } from '../../../../../../../shared/constanst/constants';

const defaultFilterReferenciaGrupo = {referencia:null,grupoFactura:null}

export const NavGroupItemSelection = (props)=>{

    const {data,onSelection,isSelected,isFirst,admExpatriados} = props;

    const [referenciaGrupoFilter, setReferenciaGrupoFiler] = useState(defaultFilterReferenciaGrupo)
    const [dataSelection, setDataSelection] = useState(undefined);

    const isInvalidReferencia = useMemo(()=> (referenciaGrupoFilter.referencia===null),[referenciaGrupoFilter])

    const ISADMEXPATRIADOS = useMemo(()=> data && 
    (data.rolPermiso===ROLES_EXPATRIADOS.ADMINISTRADOR.value || data.rolPermiso===ROLES_EXPATRIADOS.ADMINISTRADOR_GLOBAL.value),[data, ROLES_EXPATRIADOS])

    useEffect(()=>{if(isFirst===true){onSelection(dataSelection)}},[isFirst,dataSelection])

    // useEffect(()=>{
    //     if(isSelected===false || isInvalidReferencia){
    //         setReferenciaGrupoFiler(defaultFilterReferenciaGrupo);
    //     }
    // },[isSelected,isInvalidReferencia])

    useEffect(()=>{
        let _dataSelection = {...data};
        delete _dataSelection.referenciasFactura; delete _dataSelection.gruposFactura;
        
        setDataSelection({..._dataSelection,...referenciaGrupoFilter});
    },[data,referenciaGrupoFilter])

    useEffect(()=>{isInvalidReferencia===false && onSelection(dataSelection)},[isInvalidReferencia,dataSelection])

    const onChangeReferencia = (value)=>{setReferenciaGrupoFiler({...referenciaGrupoFilter,...{referencia:value}})}


    const getContent = useMemo(()=> ISADMEXPATRIADOS === true && (isSelected===true && data) &&(
        <EuiFlexGroup>
            <EuiFlexItem grow={5}>
                <EuiFormRow label="Referencia" isInvalid={isInvalidReferencia}>
                    <SelectorRefrenecias compressed data={data.referenciasFactura} isInvalid={isInvalidReferencia}
                    onChange={onChangeReferencia}
                    valueOfSelected={referenciaGrupoFilter.referencia}/>
                </EuiFormRow>
                
            </EuiFlexItem>
            <EuiFlexItem grow={5}>
                <EuiFormRow label="Grupo Factura">
                    <SelectorGrupos nullOption compressed data={data.gruposFactura} disabled={isInvalidReferencia}
                    onChange={value=>setReferenciaGrupoFiler({...referenciaGrupoFilter,...{grupoFactura:value}})} 
                    valueOfSelected={referenciaGrupoFilter.grupoFactura}/>
                </EuiFormRow>
                </EuiFlexItem>
        </EuiFlexGroup>
    ),[data,isSelected,referenciaGrupoFilter,setReferenciaGrupoFiler,ISADMEXPATRIADOS])

    const onClick = ()=>{onSelection(dataSelection)}

    return(<EuiCollapsibleNavGroup
                paddingSize='none'
                arrowDisplay="none"
                titleElement={"span"}
                buttonClassName={`btn-list-facturacion${ISADMEXPATRIADOS?'-button':''}`}
                forceState={isSelected===true?'open':'closed'}
                className={`btn-list-facturacion ${isSelected===true?'active':''}`}
                title={`${data.sociedad}`}
                iconType="visMapCoordinate"
                iconSize="m"
                titleSize="xxxs"
                isCollapsible={ISADMEXPATRIADOS}
                initialIsOpen={false}
                background={"light"}
                onToggle={(isOpen)=>{onClick()}}
                onClick={onClick}
            >{getContent}</EuiCollapsibleNavGroup>
    )
}